// @flow
import styled from 'styled-components';
import * as React from 'react';
import { below } from '../../assets/css/media';
import colors from '../../assets/css/colors';
import {
	RotatedLabel,
	PlayerTableCell,
	PlayerInfo,
	FilledIcon
} from '../';
import Revert from '../Icons/Revert';
import { TradeCell } from './TradeCell';

const InCellStyled = styled(TradeCell)`
	.filled-icon {
		margin-left: auto;
		margin-right: 4em;
		${below.desktop`
			margin-right: 1em;
		`}
	}
`;
type TCell = {
	removePlayer?: Function,
	player: Object
};
export const TradeInCell = ({ player, removePlayer }: TCell) => {
	return (
		<InCellStyled>
			<PlayerTableCell width="260px" height="60px" justify="flex-start">
				<RotatedLabel
					background={colors.liveGreen}
					text="IN"
					border_radius="2px 0 0 2px"
					rotate="-90" />
				<PlayerInfo player={player} />
			</PlayerTableCell>
			{removePlayer ? (
				<FilledIcon
					onClick={() => removePlayer({ id: player.id })}
					background={colors.red}
					className="filled-icon"
				>
					<Revert color="#fff" />
				</FilledIcon>
			) : null}
		</InCellStyled>
	);
};

export default TradeInCell;


// WEBPACK FOOTER //
// ./src/components/Trades/TradeInCell.js